import React from 'react';
import { Box, Typography } from '@mui/material';
import { ACCENT_GRAD } from '../../styles/tokens';

/** Wordmark: total-station tile + "GeoPlankton" (product name; the code base is still called surveydesk). */
export default function Logo({ size = 32, showText = true, textColor = '#1a2332' }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.1 }}>
            <Box sx={{
                width: size, height: size, borderRadius: `${size * 0.28}px`, background: ACCENT_GRAD,
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                boxShadow: '0 4px 12px -4px rgba(66,120,152,0.5)',
            }}>
                {/* Total station on a tripod: U-shaped yoke holding the telescope, body, tripod legs. */}
                <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
                    <g stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17 6.5 H23" />
                        <path d="M13.5 8.5 V17.5 H26.5 V8.5" />
                        <rect x="11.5" y="17.5" width="17" height="6" rx="1.8" />
                        <path d="M15 20.5 H19" strokeWidth="1.6" />
                        <path d="M15.5 23.5 L11 33.5 M20 23.5 V34 M24.5 23.5 L29 33.5" />
                    </g>
                    <circle cx="20" cy="12.5" r="3.4" fill="#fff" />
                </svg>
            </Box>
            {showText && (
                <Typography sx={{ fontWeight: 700, fontSize: size * 0.56, letterSpacing: -0.4, color: textColor, lineHeight: 1 }}>
                    Geo<Box component="span" sx={{ color: '#427898' }}>Plankton</Box>
                </Typography>
            )}
        </Box>
    );
}
